import { Inject } from '@odinjs/odin';

import { Endpoint, ToastService } from '@philips-emr/hpms-provider-commons';
import { HpmsTextHtmlAPI } from '@philips-emr/hpms-provider-components';
import { ActionAPI, FetchAPI, FieldAPI, FormAPI, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnCancel, OnClick, OnClose, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import { FragmentNames } from '../../codegen';
import { NegotiationHistoryAliases as Aliases } from '../../codegen/constants/aliases/negotiation-history-aliases';
import BaseController from '../BaseController';

interface Negotiation {
  dsHistory: string,
  ieStatus: number,
}

const NEGOTIATING = 2;

@Controller({ fragment: FragmentNames.NEGOTIATION_HISTORY })
class NegotiationHistoryController extends BaseController {

  @Inject(Aliases.TEXT_HTML_HISTORY)
  private textHtmlHistory: HpmsTextHtmlAPI;
  @Inject(Aliases.FORM_HISTORY)
  private formHistory: FormAPI;
  @Inject(Aliases.FETCH_HISTORIES)
  private fetchHistories: FetchAPI;
  @Inject(Aliases.FIELD_TYPE)
  private fieldType: FieldAPI;
  @Inject(Aliases.FIELD_MESSAGE)
  private fieldMessage: FieldAPI;
  @Inject(Aliases.PANEL_ADD_HISTORY)
  private panelAddHistory: PanelAPI;
  @Inject(Aliases.FIELD_HISTORY)
  private fieldHistory: FieldAPI;
  @Inject(Aliases.ACTION_ADD_HISTORY)
  private actionAddHistory: ActionAPI;

  @OnMount([Aliases.FETCH_HISTORIES, Aliases.FETCH_NEGOTIATION])
  onMountFetch(event: MountEvent): void {
    const { nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    const api = event.target as FetchAPI;
    api.setParameters({ nrSeqNegotiation });
    api.forceFetch();
  }

  @OnMount(Aliases.FIELD_HISTORY)
  onMounText(event: MountEvent): void {
    const api = event.target as FieldAPI;
    if (api.getData()) {
      const { dsHistory } = api.getData() as unknown as Negotiation;
      this.textHtmlHistory.setData(dsHistory);
    }
  }

  @OnSubmit(Aliases.FORM_HISTORY)
  onSubmitHistory(event: SubmitEvent): void {
    const body = event.record;
    const { nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    HttpService.post(Endpoint.POST.NEW_NEGOTIATION_HISTORY, { nrSeqNegotiation }, { body })
      .then(() => {
        this.cleanForm();
        this.fetchHistories.forceFetch();
        this.panelAddHistory.setVisible(false);
      }).catch((resp) => ToastService.open(resp));
  }

  @OnAfterFetch(Aliases.FETCH_NEGOTIATION)
  onAfterFetchHistories(event: FetchEvent): void {
    const data = event.data as Negotiation;
    if (!isEmptyArrayOrObject(data)) {
      this.actionAddHistory.setEnabled(data.ieStatus == NEGOTIATING);
    }
    this.fieldHistory.setState({ showValidations: false });
    this.fieldMessage.setState({ showValidations: false });
  }

  @OnCancel(Aliases.FORM_HISTORY)
  onCleanForm(): void {
    this.panelAddHistory.setVisible(false);
  }

  private cleanForm(): void {
    this.formHistory.setData({});
    this.formHistory.setRecord({});
    this.fieldType.setState({ showValidations: false });
    this.fieldMessage.setState({ showValidations: false });
  }

  @OnClick(Aliases.ACTION_ADD_HISTORY)
  onClickAddHistory(): void {
    this.panelAddHistory.setVisible(true);
  }

  @OnClose(Aliases.MODAL_HISTORY)
  onCloseModalHistory(): void {
    this.panelAddHistory.setVisible(false);
  }

}

export {
  NegotiationHistoryController,
};
